/*** IMPORTS FROM imports-loader ***/
var define = false;

const ONE_YEAR = 365*24*60*60*1000;

export default class CookieConsent{

    constructor(){

        this.selectorConsent = '#cookie-consent';
        this.selectorConfirm = '#cookie-button--got-it';
        this.isCookieConfirmed = 'isCookieConfirmed';

        this.consent = document.querySelector(this.selectorConsent);
    }

    _popupOpen(){

        if(typeof this.consent !== undefined)
            this.consent.style.display = 'flex';
    }

    _popupClose(){

        document.cookie = `${this.isCookieConfirmed}=true; path=/; expires=${this.calcExpiredDate()}`;
        this.consent.style.display = 'none';
    }

    _handleClosePopup(){

        let confirm = document.querySelector(this.selectorConfirm);
        if(typeof confirm !== undefined)
            confirm.addEventListener('click', () => {this._popupClose();});
    }

    calcExpiredDate(){
        return (new Date(new Date().getTime() + ONE_YEAR)).toUTCString();
    }

    init(){
        if(document.cookie.indexOf(this.isCookieConfirmed + '=true') !== -1)
            return false;

        this._handleClosePopup();
        this._popupOpen();
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/CookieConsent.js